import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useMutation } from '#src/hooks/graphql/useMutation.ts';

import type {
  StartOffRampBridgeKycMutation,
  StartOffRampBridgeKycMutationVariables,
} from './__generated__/useStartOffRampBridgeKyc.graphql.ts';

const START_OFF_RAMP_BRIDGE_KYC_MUTATION = gql`
  mutation StartOffRampBridgeKycMutation($input: startOffRampBridgeKycInput!) {
    startOffRampBridgeKyc(input: $input) {
      kycLinkUrl
      bridgeAccount {
        id
        kycStatus
      }
      errors {
        message
        code
      }
    }
  }
` as TypedDocumentNode<
  StartOffRampBridgeKycMutation,
  StartOffRampBridgeKycMutationVariables
>;

export const useStartOffRampBridgeKyc = () => {
  const [mutate] = useMutation(START_OFF_RAMP_BRIDGE_KYC_MUTATION, {
    showErrorsInForm: true,
  });

  return async (returnUrl: string) =>
    mutate({ variables: { input: { returnUrl } } });
};
